import styled from "styled-components";

export const TodoFormInput = styled.input`
    background: #bababa;
    color: #fff;
    border: none;
    outline: none;
    width: 99%;
`;